import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';

export default function UseAutoCompleteSearch({
    data,
    label,
    onSelectChange,
    selected,
    noOptionsText,
    size = 'medium',
    onInputChange,
}) {
    const onSelectChanged = (newValue) => {
        if (onSelectChange) {
            onSelectChange(newValue);
        }
    };

    const onInputChanges = (newValue) => {
        if (onInputChange) {
            onInputChange(newValue);
        }
    };

    return (
        <div style={{ marginBottom: 16 }}>
            <Autocomplete
                ListboxProps={{ style: { maxHeight: '15rem' }, position: 'bottom-start', height: 50 }}
                id="checkboxes-tags-demo"
                options={data}
                disableCloseOnSelect
                noOptionsText={noOptionsText}
                onChange={(event, newValue) => {
                    onSelectChanged(newValue);
                }}
                onInputChange={(event, newInputValue, reason) => {
                    if (reason === 'clear' && event.type === 'click') {
                        onInputChanges(null);
                    } else {
                        onInputChanges(newInputValue);
                    }
                }}
                defaultValue={selected}
                value={selected}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                style={{ width: 250, marginTop: 10, paddingRight: 10, maxHeight: 350, overflowY: scroll }}
                renderInput={(params) => (
                    <TextField sx={{ overflowY: scroll }} {...params} label={label} placeholder={label} size={size} />
                )}
            />
        </div>
    );
}

UseAutoCompleteSearch.propTypes = {
    data: PropTypes.object.isRequired,
    label: PropTypes.object.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    selected: PropTypes.object.isRequired,
    noOptionsText: PropTypes.object.isRequired,
    size: PropTypes.object.isRequired,
    onInputChange: PropTypes.object.isRequired,
};
